import type { ComponentProps, ReactNode } from 'react';
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateTitle,
  type Icon,
} from '@customerio/pluma-components/react';
import * as styles from './blank-slate.css';

type BlankSlateProps = {
  icon: ComponentProps<typeof Icon>['name'];
  title: string;
  description: string;
  children: ReactNode;
};

/** Centered empty state: icon, title, description, and a CTA slot. */
export function BlankSlate({ icon, title, description, children }: BlankSlateProps) {
  return (
    <EmptyState variant="default" className={styles.blankSlate}>
      <EmptyStateTitle data-test-integrations-blank-slate-title icon={icon}>
        {title}
      </EmptyStateTitle>
      <EmptyStateDescription data-test-integrations-blank-slate-description>{description}</EmptyStateDescription>
      <EmptyStateActions data-test-integrations-blank-slate-cta>{children}</EmptyStateActions>
    </EmptyState>
  );
}
